import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CategoryEntity } from "@modules/vendor/entities/vendor.entity";

export interface VendorState {
  id: string;
  name: string;
  avatarUrl: string;
  address: string;
  images: string[];
  totalFollower: number | undefined;
  weekFollowingCount: number | undefined;
  averageRating: string;
  category?: CategoryEntity;
  loyaltyDisabled?: boolean;
}

export interface SetVendorPayloadAction {
  id?: string;
  name?: string;
  avatarUrl?: string;
  address?: string;
  images?: string[];
  totalFollower?: number | undefined;
  weekFollowingCount?: number | undefined;
  averageRating?: string;
  category?: CategoryEntity;
  loyaltyDisabled?: boolean;
}

const initialState = {
  id: "",
  name: "",
  avatarUrl: "",
  address: "",
  totalFollower: undefined,
  weekFollowingCount: undefined,
  images: [],
  averageRating: "",
  category: undefined,
  loyaltyDisabled: false,
} as VendorState;

export const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    setVendor: (state, action: PayloadAction<SetVendorPayloadAction>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const vendorSelector = (state: any) => state.vendor as VendorState;

export const { setVendor } = vendorSlice.actions;
export default vendorSlice.reducer;
